import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Per-module "Generate Report" entry point -- links into ReportPage filtered
// to just this module's section via ?section=, reusing the same report
// engine the project-level button (Dashboard header) points at unfiltered.
const ReportButton = ({ section, projectId }) => {
  const navigate = useNavigate();
  if (!projectId) return null;
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={() => navigate(`/dashboard/${projectId}/report?section=${section}`)}
      className="bg-black/[0.03] border-border text-foreground hover:bg-black/[0.06]"
      data-testid={`report-btn-${section}`}
    >
      <FileText className="w-3.5 h-3.5 mr-1.5" />
      Report
    </Button>
  );
};

export default ReportButton;
